import { render, staticRenderFns } from "./SanitaryEquipment.vue?vue&type=template&id=22da1d40&"
import script from "./SanitaryEquipment.vue?vue&type=script&lang=js&"
export * from "./SanitaryEquipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports